import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import Immutable from 'immutable';

import * as optimizelyUtil from 'utils/optimizely';

import CustomControlLayout from 'layouts/CustomControlLayout/CustomControlLayout';
import ModalLayout from 'layouts/ModalLayout/ModalLayout';
import NotificationsLayout from 'layouts/NotificationsLayout/NotificationsLayout';
import PopoverLayout from 'layouts/PopoverLayout/PopoverLayout';

import modalContent from 'components/Modal/content';

import '../../styles/vendor.scss';
import '../../styles/all.scss';

/* istanbul ignore next */
const mapStateToProps = state => ({
  baseState: state.baseState,
  featureFlags: state.featureFlags,
  modal: state.modal,
  isMobileBreakpoint: state.appState.get('isMobileBreakpoint', true),
});

export class CoreLayout extends Component {
  static propTypes = {
    baseState: PropTypes.object,
    children: PropTypes.element,
    featureFlags: PropTypes.object,
    isMobileBreakpoint: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    modal: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  };

  static defaultProps = {
    baseState: Immutable.fromJS({}),
    featureFlags: Immutable.fromJS({
      classNameList: [],
    }),
  };

  componentWillMount() {
    this.onRouteChange();
  }

  componentWillReceiveProps() {
    this.onRouteChange();
  }

  onRouteChange() {
    const { location } = this.props;

    if (location.action === 'POP' || location.action === 'PUSH') {
      const userAttributes = {
        type: 'user',
        attributes: {
          device_type: optimizelyUtil.getDeviceType(),
        },
      };

      if (this.searchHasChildren()) {
        userAttributes.attributes.search_with_children = true;
      }

      optimizelyUtil.push(userAttributes);
    }
  }

  searchHasChildren() {
    const { baseState } = this.props;
    const getChildrenFromBaseState = ['queryState', 'props', 'cdn', 'arrayValue'];
    const children = baseState.getIn(getChildrenFromBaseState, Immutable.fromJS([]));

    return children.size;
  }

  get featureFlagsClassName() {
    const { featureFlags } = this.props;
    let classNameList = featureFlags.get('classNameList').toJS();
    classNameList = classNameList.map(className => `core-layout--${className}`);

    return classNameList.join(' ');
  }

  get layoutClassName() {
    const { isMobileBreakpoint } = this.props;
    return isMobileBreakpoint ? 'core-layout--mobile' : 'core-layout--desktop';
  }

  render() {
    const { modal } = this.props;
    const modalData = modal && modal.name && !modal.config.isSubPage && modalContent(modal);

    return (
      <div className={`core-layout ${this.featureFlagsClassName} ${this.layoutClassName}`}>
        <NotificationsLayout />
        {this.props.children}
        { modalData && (
          <ModalLayout icon={modalData.icon} modalConfig={modal.config}>
            {modalData.content}
          </ModalLayout>
        )}
        <PopoverLayout />
        <CustomControlLayout />
      </div>
    );
  }
}

export default connect(mapStateToProps)(CoreLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/CoreLayout/CoreLayout.jsx
 **/